import React from 'react';
import SbEditable from 'storyblok-react';
import sparksBlueImage from '~/icons/sparks-blue.svg';


export default function TextCardAndGrid({ blok }) {

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="flex flex-col">
        <h2 className="text-h2 max-w-md mb-12">
          {blok.heading}
        </h2>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-2">
          {blok.items.map((li) => (
            <SbEditable content={li} key={li._uid}>
              <div className="inline-flex items-start md:mx-0" style={{ maxWidth: '292px' }}>
                <img className="mr-3" src={sparksBlueImage} alt="" style={{ maxWidth: '40px' }} />
                <p className="mt-2 font-bold text-18px md:mt-1 md:text-20px">{li.heading}</p>
              </div>
            </SbEditable>
          ))}
        </div>
      </div>
    </SbEditable>
  );
}
